module.exports = __webpack_public_path__ + "static/media/gryphon_musee_abovethetrees_5.c57a142a.jpg";